<div class="modal static-modal {{isActive ? 'active': ''}}" *ngIf="isActive">
    <div class="modal-overlay"></div>
    <div class="modal-content">
        <div class="modal-content__head">
            <p>{{lang === 'tr' ? 'N Kolay\'ı İndir' : 'Download N Kolay'}}</p>
            <a href="#" class="modal-close" (click)="close($event)"><img src="assets/images/icons/close.svg" alt=""></a>
        </div>
        <div class="modal-content__body">
            <div class="modal-sms-content">
                <h4 *ngIf="lang === 'tr'">Uygulamanın indirme linkini cep telefonuna göndereceğiz.</h4>
                <h4 *ngIf="lang !== 'tr'">We will send a link<br>for downloading the app.</h4>
                <div class="input-comp mb-20">
                    <p>{{lang === 'tr' ? 'Telefon Numaran' : 'Phone Number'}}</p>
                    <input type="text" [(ngModel)]="phonenumber" name="gsm" maxlength="10" placeholder="53x">
                </div>
                <div class="error-message" *ngIf="hasError">
                    <p>{{lang === 'tr' ? 'Lütfen Telefon numaranızı giriniz.' : 
                        'Please fill phone number field.'}}</p>
                </div>
                <section>                    
                    <p *ngIf="lang === 'tr'">Burada alınan cep telefonu numaran, N Kolay mobili indirme linkinin sana gönderilmesi amacıyla
                        aydınlatma metninde belirtildiği şekilde işlenecektir. Aktif Yatırım Bankası A.Ş. Kişisel
                        Verilerin Korunması Kanunu Hakkında Aydınlatma Metni’ne her zaman <a
                            href="https://www.nkolay.com/api/uploads/20210917152556272.pdf" target="_blank">buradan</a>
                        ulaşabilirsin.</p>
                    <p *ngIf="lang !== 'tr'">Your phone number will be processed in order to send you a link to download the app. 
                        You can visit <a
                        href="/en/information-note-for-the-law-on-protection-of-personal-data" target="_blank">this</a> link to see our Informatıon Note for the Law on Protectıon of Personal Data.  </p>
                </section>
                <div class="cta">
                    <app-aktif-button [disabled]="successStatus || failStatus" [data]="getBtnByLang()"
                        (click)="sendPhoneNumber($event)"></app-aktif-button>
                </div>
                <div class="result-messages success" *ngIf="successStatus">
                    <p *ngIf="lang === 'tr'">Harika, indirme linki telefon numaranıza SMS olarak iletilmiştir.</p>
                    <p *ngIf="lang !== 'tr'">Great, the download link has been sent to your phone number via SMS.</p>
                </div>
                <div class="result-messages error" *ngIf="failStatus">
                    <p *ngIf="lang === 'tr'">Hata, SMS gönderilemedi, lütfen daha sonra tekrar deneyin.</p>
                    <p *ngIf="lang !== 'tr'">Error, SMS could not be sent, please try again later.</p>
                </div>
            </div>
        </div>
    </div>
</div>